

define(['angular', 'squid/index', 'text!./template.html', 'js/lib/index', 'xo-page-components/src/value-props/directive', '../lib/util'], function (angular, module, template) {
  return angular.module('xo-multistep-signup-address-normalization.directive', ['squid', 'xo-value-props.directive']).directive('xoMultistepSignupAddressNormalization', ['$rootScope', function ($rootScope) {
    return {
      template: template,
      scope: {
        id: '=?',
        address: '=?',
        doneFn: '=?'
      },
      controller: ['$scope', '$locale', '$config', function ($scope, $locale, $config) {}]
    };
  }]);
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/directive.js
// module id = ../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/directive.js
// module chunks = 0